import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { promptsSelector } from "../../../../store/slices/prompts";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import { companiesSelector } from "../../../../store/slices/company";
import { convertArrayToDictionary } from "../../../../common/utils";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import _ from 'lodash';
import moment from "moment";

const PromptCompare = ({ open = false, handleClose,selectedData, comparisonType }) => {
  const { historyPromptDetails } = useSelector(promptsSelector);
  const selectedDataMemo=useMemo(()=>_.orderBy(selectedData,date=>date,'desc'),[selectedData])
  // console.log(selectedDataMemo)
  const { users } = useSelector(companiesSelector);
  const comparisonMemo=useMemo(()=>{
  let data= [...historyPromptDetails]
  const oldValue=_.find(data,it=>it.sysStartTime===selectedDataMemo[1])
  const newValue=_.find(data,it=>it.sysStartTime===selectedDataMemo[0])
  return([newValue,oldValue])
  },[historyPromptDetails,selectedDataMemo])
    
  const userDic = React.useMemo(
    () =>
      convertArrayToDictionary(
        _.map(_.cloneDeep(users), (it) => {
          it.name = it.firstName + (it.lastName ? " " + it.lastName : "");
          return it;
        }),
        "userId"
      ),
    [users]
  );

  const oldText=useMemo(()=>{
    const data=comparisonMemo[1]
    return data
  },[comparisonMemo])
  const newText=useMemo(()=>{
    const data=comparisonMemo[0]
    return data
  },[comparisonMemo])

  const onClose = () => {
    handleClose();
  };
const handleCopy=(text)=>{
  navigator.clipboard.writeText(text);
}

const dialogTitle  = useMemo(()=>{
  if(comparisonType==='promptText') return 'Prompts Text Comparison'
  if(comparisonType==='responseJsonSchema') return 'Response Json Schema Comparison'
  if(comparisonType==='systemPrompt') return 'System Prompt Comparison'
  return 'Comparison'
},[comparisonType])

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant="h5">{dialogTitle}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers sx={{pt:0}}>
        <Stack direction={'row'} sx={{position:'sticky',top:0,left:0,backgroundColor:theme=>theme.palette.background.paper,py:1}}>
          <Stack direction='row' spacing={2} alignItems={'center'} sx={{width:'50%'}}>
            
            <Typography  sx={{color:'#AEB7C8'}}>{"Modified by "+(userDic[oldText?.modifiedBy]?.name?userDic[oldText?.modifiedBy]?.name:'')+", on "+moment.utc(oldText?.sysStartTime)?.local().format("MM/DD/YYYY hh:mm A")}</Typography>
            <Tooltip arrow disableInteractive title='Copy'><span>
            <IconButton size='small' onClick={()=>handleCopy(oldText?.[comparisonType??"promptText"])}><FileCopyIcon fontSize="small"/></IconButton>
            </span></Tooltip>
            </Stack>
            <Stack direction='row' spacing={2} alignItems={'center'} sx={{width:'50%'}}>
            <Typography sx={{color:'#AEB7C8'}}>{"Modified by "+(userDic[newText?.modifiedBy]?.name?userDic[newText?.modifiedBy]?.name:'')+", on "+moment.utc(newText?.sysStartTime)?.local().format("MM/DD/YYYY hh:mm A")}</Typography>
            <Tooltip arrow disableInteractive title='Copy'><span>
            <IconButton size='small' onClick={()=>handleCopy(newText?.[comparisonType??"promptText"])}><FileCopyIcon fontSize="small"/></IconButton>
            </span></Tooltip>
            </Stack>
        </Stack>
      <ReactDiffViewer
      styles={{ marker: { display: "none" },variables:{
        light:{diffViewerTitleBorderColor:'black'},
      }, diffContainer:{background:'inherit'} }}
      compareMethod={DiffMethod.CHARS}
      oldValue={oldText?.[comparisonType??"promptText"]}
      newValue={newText?.[comparisonType??"promptText"]}
      splitView={true}
      hideLineNumbers={true}
    />
      </DialogContent>
      <DialogActions>
      <Stack direction="row" spacing={2} ml={2} py={1} sx={{ width: "100%" }}>
          <Button variant="outlined" onClick={onClose}>Cancel</Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default PromptCompare;
